import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5v18l7-3 7 3V3z"
}), 'TurnedInSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TurnedInSharp.js
// module id = 6952
// module chunks = 2